class MonofidelityTheme {
  constructor() {
    this.bindMobileNavigation();
    this.bindSortSelects();
    this.bindProductForms();
  }

  bindMobileNavigation() {
    document.querySelectorAll('[data-menu-toggle]').forEach((button) => {
      const nav = document.querySelector('[data-mobile-nav]');
      if (!nav) return;
      button.addEventListener('click', () => {
        const open = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', String(!open));
        nav.hidden = open;
      });
    });
  }

  bindSortSelects() {
    document.querySelectorAll('[data-sort-select]').forEach((select) => {
      select.addEventListener('change', () => select.form?.requestSubmit());
    });
  }

  bindProductForms() {
    document.querySelectorAll('[data-product-form]').forEach((form) => {
      const variantSelect = form.querySelector('[data-variant-select]');
      const price = form.closest('[data-product-root]')?.querySelector('[data-product-price]');
      const button = form.querySelector('[data-add-to-cart]');
      if (!(variantSelect instanceof HTMLSelectElement)) return;

      variantSelect.addEventListener('change', () => {
        const option = variantSelect.selectedOptions[0];
        if (price && option.dataset.price) price.textContent = option.dataset.price;
        if (button instanceof HTMLButtonElement) {
          const available = option.dataset.available === 'true';
          button.disabled = !available;
          button.textContent = available ? button.dataset.addLabel : button.dataset.soldLabel;
        }
      });
    });
  }
}

document.addEventListener('DOMContentLoaded', () => new MonofidelityTheme());
